import React from 'react'
import { Icon } from '../Icon'
import { Badge } from 'react-bootstrap'
export enum StatusTypeEnum {
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  muted = 'muted',
}

export type StatusProps = {
  className?: string
  value?: string

  type?: StatusTypeEnum | string

  color?: string
}
export const Status = ({ value, type, color }: StatusProps) => {
  let className = `text-${type}`
  if (!type && !color) {
    if (value && value.toLowerCase() === 'inactive') {
      className = `text-${StatusTypeEnum.muted}`
    } else if (value && value.toLowerCase() === 'pending') {
      className = `text-${StatusTypeEnum.warning}`
    } else {
      className = `text-${StatusTypeEnum.info}`
    }
  } else if (color) {
    className = ''
  }

  return (
    <span title={value} style={{ marginRight: '2px', color }}>
      <Icon name={'circle'} className={className} />
    </span>
  )
}

export const StatusBadge = ({ status, statusColor, pill }: { status: string; statusColor: string; pill?: boolean }) => {
  return (
    <Badge pill={pill} bg={''} style={{ backgroundColor: statusColor, color: 'white' }}>
      {status}
    </Badge>
  )
}
